"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
exports.generateURL = function (_a) {
    var name = _a.name, _b = _a.fileType, fileType = _b === void 0 ? 'png' : _b, rest = __rest(_a, ["name", "fileType"]);
    var url = new URL("https://robohash.org/" + name + "." + fileType);
    Object.entries(rest)
        .map(transformKeyAndValue)
        .forEach(function (_a) {
        var key = _a[0], value = _a[1];
        url.searchParams.set(key, value);
    });
    return url.href;
};
var getSetForType = function (type) {
    switch (type.toLowerCase()) {
        case 'robot':
            return 'set1';
        case 'alien':
            return 'set2';
        case 'head':
            return 'set3';
        case 'cat':
            return 'set4';
        default:
            return 'set1';
    }
};
var transformKeyAndValue = function (_a) {
    var key = _a[0], value = _a[1];
    switch (key) {
        case 'type': {
            var val_1 = typeof value === 'number' ? "set" + value : getSetForType(value);
            return ['set', val_1];
        }
        case 'background':
            return ['bgset', "bg" + value];
        case 'gravatar':
            return value ? ['gravatar', 'yes'] : [];
        case 'size':
            var val = typeof value === 'number' ? value + "x" + value : value;
            return ['size', val];
        default:
            return [];
    }
};
var ReactRoboHash = function (_a) {
    var alt = _a.alt, children = _a.children, _b = _a.className, className = _b === void 0 ? 'Robohash' : _b, rest = __rest(_a, ["alt", "children", "className"]);
    var url = exports.generateURL(rest);
    return children
        ? children(url)
        : React.createElement("img", { src: url, alt: alt || "Robohash-" + rest.name, className: className });
};
exports.default = ReactRoboHash;
//# sourceMappingURL=index.js.map